import { render } from "./AllServices.vue?vue&type=template&id=d2ff5784"
import script from "./AllServices.vue?vue&type=script&lang=js"
export * from "./AllServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__